<!-- /src/views/Search.vue -->
<template>
  <LayoutFullWidth class="landing--page"
  :class="{'landing--search': includeQuestion}"
  >
    <template v-slot:header>
      <h1 id="page-header" class="page-header">Search Results</h1>
          <div class="card-grid-header__actions button__group">
            <button
              class="filter--trigger button button--gray button--sm"
              @click="toggleDocuments()"
            >
              <span v-if="type != 'documents'">Search Documents</span>
              <span v-else>Search Content</span>
            </button>
            <button
              class="filter--trigger button button--gray button--sm"
              @click="toggleFilters()"
            ><span v-if="activeQueries.length > 0">Modify Filtered Results</span>
            <span v-else>Filter Results</span></button>
            <Sort />
          </div>
    </template>
    <template v-slot:content>
        <div class="filter-panel"
          v-show="showFilters"
        >
          <Filters postType="all" />
          <button
            class="button button--gray button--medium button--accent"
            @click="toggleFilters()"
          >Close Filter Panel</button>
        </div>
        <header class="card-grid-header">
          <ActiveQueries />
        </header>
        <div class="main-content">
          <Loader v-if="isLoading && cardCount == 0" color="gray" />
          <NoResults v-else-if="cardCount == 0">
            <h2>Whoops! Looks like we do not have content related to your query.</h2>
        If you think this topic would be helpful to others, please consider using the "Need Help?" feature in the upper right.
          </NoResults>
          <div v-else class="content-with-sidebar">
            <CardGrid :cards="pageCards" :type="type"/>
            <div class="sidebar">
              <h2 class="sidebar__title">Documents</h2>
              <Listing :listing="docsCards"  :removeElements="['progressStatus', 'bookmarks']" />
            </div>
          </div>

          <Pagination v-if="totalPages > 1" :page="page" :total="totalPages" />
      </div>
    </template>
  </LayoutFullWidth>
</template>

<script>
import _isUndefined from 'lodash/isUndefined'
import LayoutFullWidth from '@/components/layouts/FullWidth'
import CardGrid from '@/components/common/Card/CardGrid'
import Listing from '@/components/common/List/Listing'
import Sort from '@/components/common/Sort'
import Filters from '@/components/common/Sidebar/Filters'
import Pagination from '@/components/common/Pagination'
import searchMixin from '@/mixins/searchMixin'
import Loader from '@/components/common/Loaders/Loader'
import NoResults from '@/components/common/Loaders/NoResults'
import ActiveQueries from '@/components/common/Search/ActiveQueries'
import { deepSearch } from '@/components/common/utils/helpers.js'
import defaults from 'lodash/defaults'
import questionMixin from '@/mixins/questionMixin'
// import resizeMixin from '@/mixins/resizeMixin'
// import { mapGetters } from 'vuex'


export default {
  name: 'search',
  data() {
    return {
      itemsPerPage: 18,
      docsPerPage: 19,
      cardCount: 0,
      documentCount: 0,
      // isLoading: true,
      showDocuments: false,
    }
  },
  computed: {
    page() {
      const { page } = Object.create(this.$route.query)
      return typeof page != 'undefined' ? page : 1

    },
    isLoading() {
      return !this.$store.getters['posts/searchResultsLoaded']
    },
    cards() {
      const { sort } = Object.assign({}, this.$route.query)
      let cards = this.$store.getters['posts/getSearchResults']
      // // the order of these functions is important since sorting needs to happen after input search
      // cards = this.includeDocuments(cards)
      cards = this.searchViaInput(cards)
      cards = this.filterCards(cards)

      // console.log(cards)
      // default sort of cards
      if (_isUndefined(sort)) cards = this.mikeSort(cards)
      if (cards.length > 0) this.cardCount = cards.length

      return cards
    },

    documents() {
      const { cards } = this
      // // the order of these functions is important since sorting needs to happen after input search
      const docs = this.getDocuments(cards)
      if (docs.length > 0) this.documentCount = docs.length

      return docs
    },

    type() {
      const { $route } = this
      const { query } = $route
      return query['type']
    },
    // defines the cards displayed on page
    pageCards() {
      return this.cards.slice(
        (this.page - 1) * this.itemsPerPage,
        (this.page - 1) * this.itemsPerPage + this.itemsPerPage,
      )
    },

    // defines the cards displayed on page
    docsCards() {
      return this.documents.slice(
        (this.page - 1) * this.docsPerPage,
        (this.page - 1) * this.docsPerPage + this.docsPerPage,
      )
    },

    // itemsPerPage() {
    //   return this.$store.getters['posts/getItemsPerPage']('searchResults')
    // },

    totalPages() {
      const docpages = this.documents.length / this.docsPerPage
      const cardpages = this.cards.length / this.itemsPerPage
      return Math.ceil(Math.max(docpages, cardpages))
    },

  },

  mixins: [searchMixin, questionMixin],

  watch: {
    cards(newCards) {
      this.cardCount = newCards.length
      return newCards
    },
  },

  methods: {
    getSearchInputQuery() {
      const { $route } = this
      const { query } = $route
      return !_isUndefined(query['search']) ? query['search'] : ''
    },
    toggleDocuments() {
      const { $route, type } = this
      const { name } = $route
      let { ...query } = this.$route.query
      const queryModifier = {}

      if (type != 'documents') {
        queryModifier['type'] = 'documents'
      } else {
        delete query['type']
      }

      query = Object.assign(defaults(queryModifier, query))
      this.$router.push({
        name,
        query,
      })

    },

    includeDocuments(cards) {
      let output = []
      cards.forEach(t => {
        output.push(t)
        let downloadableFiles = deepSearch(t, ['acf', 'downloadable_files'])
        if (downloadableFiles && Array.isArray(downloadableFiles)) {
          downloadableFiles.forEach(file => {
            const fileObj = file.file
            if (fileObj && typeof fileObj == 'object') {
              output.push({
                ...t,
                ID: fileObj.ID,
                id: fileObj.ID,
                post_title: fileObj.title,
                file: fileObj,
                post_type: 'downloadable_file',
                type: 'documents',
              })
            }
          })
        }
      })
      return output

    },

    getDocuments(cards) {
      let output = []
      cards.map(t => {
        let downloadableFiles = deepSearch(t, ['acf', 'downloadable_files'])
        if (downloadableFiles && Array.isArray(downloadableFiles)) {
          downloadableFiles.forEach(file => {
            const fileObj = file.file
            if (fileObj && typeof fileObj == 'object') {
              // console.log(file)
              output.push({
                ...t,
                ID: fileObj.ID,
                id: fileObj.ID,
                post_title: fileObj.title,
                file: fileObj,
                post_type: 'downloadable_file',
                type: 'documents',
              })
            }
          })
        }
      })
      return output
    }
  },

  beforeMount() {
    this.$store.dispatch('updateSearchInputValue', this.getSearchInputQuery())
    // this.searchVisible = this.$route.name === 'search' ? true : false
    // this.onResize()
    // console.log(this.$route)
    // this.$store.dispatch('posts/getAll')

  },

  mounted() {
    this.$store.dispatch('updatePageTitle', 'Search')
  },

  beforeDestroy() {
    this.$store.dispatch('updateSearchInputValue', '')
  },

  components: {
    LayoutFullWidth,
    CardGrid,
    Listing,
    Pagination,
    Filters,
    ActiveQueries,
    Sort,
    Loader,
    NoResults,
  },
}
</script>


<style scoped>

.landing {
  /* &--search {
    padding-right: 4.5rem;

    @media(--phone) {
      padding-right: 6rem;
    }

  } */
}
.main-content {
  height: 100%;
}

.sidebar {
  &__title {
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 900;
    margin-bottom: 0;
  }
}
.card-grid-header {
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  margin: 0;
  margin-bottom: 1rem;

  h2 {
    margin-bottom: 0;
  }

  &__actions {
    font-size: 0.7em;
    justify-self: start;
    grid-template-columns: 1fr;
    display: grid;
    @media(--tablet) {
      display: flex;
      /* grid */
    }
  }
}

.content-with-sidebar {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media(--tablet) {
    grid-template-columns: 3fr 1fr;
  }
}

.filter-panel {
  display: grid;
  margin-bottom: 1rem;
  padding: 1rem;
  gap: 1rem;
  background-color: rgba(var(--gray-RGB), .3);
  border-radius: 4px;

  &> button {
    justify-self: end;
    font-size: .6rem;
    padding: .35rem .5rem;
  }
}

.form__control {
  margin: 0;
}

</style>
